// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2iZA6","resendInfoText":"OnGoingPaymentBox_resendInfoText__2f_ip"};